import { Flex } from '@chakra-ui/react';
import { Radio } from '@morressier/alembic';
import { ChangeEventHandler } from 'react';
import { Control, Controller } from 'react-hook-form';

type IValue = string;

interface RadioGroupProps {
  name: string;
  control: Control<any>;
  options: {
    value: IValue;
    children: React.ReactNode;
  }[];
  defaultValue?: IValue;
  required?: boolean;
  gap?: number;
}

export const FundingGenericRadioGroup = (props: RadioGroupProps) => (
  <Controller
    name={props.name}
    control={props.control}
    defaultValue={props.defaultValue ?? ''}
    rules={{ required: props.required ? 'This field is required.' : false }}
    render={({ field: { onChange, value } }) => (
      <Flex flexDirection="column" gap={props.gap ?? 0}>
        {props.options.map(option => (
          <Radio
            key={`${option.value}`}
            name={props.name}
            value={option.value}
            onChange={
              (() =>
                onChange({
                  exists: option.value,
                  value: []
                })) as ChangeEventHandler<HTMLInputElement>
            }
            checked={value?.exists === option.value}
            ariaLabel={`${props.name}-${option.value}`}
            id={`${props.name}-${option.value}`}
          >
            {option.children}
          </Radio>
        ))}
      </Flex>
    )}
  />
);
